
export const ru = {
  "common": {
    "my-fullname": "Алексей Кузнецов",
    "page-not-exist": "Страницы не существует"
  },
  "menu": {
    "home": "Главная",
    "contacts": "Контакты",
    "todos": "Список дел",
    "cats": "Коты",
    "quotes": "Цитаты",
    "users": "Юзеры"
  },
  "home": {
    "welcome-title": "Добро пожаловать на мою страницу!",
    "about-me-title": "Кратко обо мне",
    "skills-title": "Умения",
    "technology": "Технологии",
    "confident": "уверенно",
    "average": "средне",
    "beginner": "начальный",
    "soft-skills": "Общие навыки",
    "soft-skills-list": "адаптивность, коммуникативность, креативность, критическое мышление, позитивный подход, гибкость",
    "english-proficiency": "Английский язык"
  },
  "contacts": {
    "h1-title": "Мои контакты"
  },
  "todo": {
    "todo-h1": "Список дел",
    "textarea-placeholder": "напишите свое будущее дело...",
    "search-placeholder": "найти дело",
    "add-todo": "Добавить дело",
    "select-importance-level": "Уровень важности",
    "select-difficult-level": "Уровень сложности",
    "low": "Низко",
    "under-average": "Ниже среднего",
    "average": "Средне",
    "high": "Важно",
    "highest": "Очень важно",
    "easier": "Простейше",
    "easy": "Просто",
    "medium": "Средне",
    "hard": "Сложно",
    "very-hard": "Очень сложно",
    "sort-by": "Сортировать по",
    "date": "Дата",
    "importance": "Важность",
    "difficult": "Сложность",
    "no-todos": "Нет дел",
    "created": "Создано"
  },
  "big-texts": {
    "about-me": "Привет! Меня зовут Алексей, и я начинающий веб-разработчик :) Проживаю в небольшом городке на Украине, и из-за отсутствия рабочих возможностей в моем городе я решил освоить проффессию, которая позволит мне находить работу удаленно. После анализа, мой выбор остановился на веб-разработке в направлении фронт-энд. Постепенно я начал углублятся в эту отрасль, выучил HTML, CSS, JavaScript и на данный момент в процессе изучения фреймворка React. Сначала было сложно, но сейчас обучение начало давать свои плоды и я понимаю, что смогу сделать всё, вопрос в уровне упорства и сил которые нужно приложить!"
  }
}